// extracted by mini-css-extract-plugin
export default {"sessionDeleteOuterCard":"ConfirmationPopup_sessionDeleteOuterCard__+9qtb"};